import React from 'react';

import { createOrderByQueryVariable } from 'src/utils/gql';

import { DEFAULT_FILTER_CONTEXT_VALUE, FilterContext } from './FilterContext';
import type { FilterContextValue, FilterType } from './types';

export type FilterProviderProps = {
  defaultSortOption?: FilterContextValue['sortOption'];
  defaultFilters?: FilterContextValue['filter'];
};

export const FilterProvider: React.FC<React.PropsWithChildren<FilterProviderProps>> = ({
  children,
  defaultSortOption = DEFAULT_FILTER_CONTEXT_VALUE.sortOption,
  defaultFilters = DEFAULT_FILTER_CONTEXT_VALUE.filter,
}) => {
  const [sortOption, setSortOption] = React.useState(defaultSortOption);
  const [filter, setFilter] = React.useState(defaultFilters);
  const [tableFilter, setTableFilter] = React.useState<FilterType>();

  const queryParams = React.useMemo(
    () => ({
      filter,
      sort: sortOption ?? null,
    }),
    [filter, sortOption],
  );

  const contextValue = React.useMemo((): FilterContextValue => {
    return {
      sortOption,
      sortQueryVariable: createOrderByQueryVariable(sortOption),
      setSortOption,
      filter,
      tableFilter,
      setTableFilter,
      setFilter,
      queryParams,
    };
  }, [filter, queryParams, sortOption, tableFilter]);

  return <FilterContext value={contextValue}>{children}</FilterContext>;
};
